// src/redux/PublicCity/publicCityApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// GET /public/cities/search?search=
export const searchPublicCitiesAPI = async (search) => {
  try {
    const response = await apiService.get(endpoints.searchPublicCities, {
      search,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
